<template>
    <div class="question padded">
        <a class='scroll-point'></a>
        <p class="page-number">{{ pageNumber }}/{{numQuestions}}</p>
        <h1 class="question-heading">{{ heading }}</h1>
        <div v-if="pageNumber == 7" class="coutryContbx-holder">
        <p class="aplyLabel">Select all that apply</p>
        <div class="progress-bar-wrapper" v-show="isVisible">
            <div class="progress"><span :style="{left: percent}" class="progress-no">{{percent}}</span>
                <div class="progress-bar" role="progressbar" :style="{width: percent}" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
        </div>
            <div class="selectAll-container">
                <div class="cotryhead">
                    <div class="topbx">
                        <label class="form-check-label" for="selectAll"> Select All
                            <input type="checkbox" id="selectAll" @click="checkAll()" v-model="isCheckAll" ref="selectAllCheckbox">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
                <div class="worldMap-holder" key="selected" ref="cardWrapper">
                    <div class="image-container ">
                        <img class="question-card-img" :src="require('coffee-preferences/select_all_country.png')" alt="Question Image">
                    </div>
                </div>
            </div>
            <div v-for="region in regionOptions">
                <div v-if="region == 'Central America'">
                    <div class="countRow">
                        <div class="cotryhead outerwrap">
                            <div class="topbx">
                                <label class="form-check-label" for="cntralAmerica"> Central America
                                    <input type="checkbox" id="cntralAmerica" v-bind:value='region' v-model='regions' @change='updateCheckall()' ref="allCentralAmerica">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="btmbx descpbx">
                                <h5>In Central America, you’ll find varying acidity, but usually beans from this region are known for their balance, which makes them good for people just getting started on their relationship with coffee. Not to bitter, not too acidic, fairly smooth flavors, like chocolate. Costa Rica is known for heavier-bodied coffee, while if you go west to Mexico, you’ll find something a little lighter.</h5>
                            </div>
                        </div>
                        <div class="question-cards-wrapper" key="selected" ref="cardWrapper">
                            <div v-for="(option, i) in centralAmerica" class="question-card" @click="selectOption(option, i)" ref="questionCard">
                                <div :class="{'active': selectedOptions.indexOf(option) > -1}" >
                                    <img class="question-card-img" :src="require('coffee-preferences/' + option.image_name)" alt="Question Image">
                                    <p class="option-name">{{ option.name }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="region == 'South America'">
                    <div class="countRow">
                        <div class="cotryhead outerwrap">
                            <div class="topbx">
                                <label class="form-check-label" for="southAmrica"> South America
                                    <input type="checkbox" id="southAmrica" v-bind:value='region' v-model='regions' @change='updateCheckall()' ref="allSouthAmerica">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="btmbx descpbx">
                                <h5>From South America, we get beans that have a wider flavor profile, but coffee drinkers are probably most well versed on the beans of Colombia, which is one of the top coffee producing countries in the world. From here, you can expect an even, well-rounded taste; moderate acidity and sweetness, and a medium to full body, probably the kind of coffee you are already most used to drinking.</h5>
                            </div>
                        </div>
                        <div class="question-cards-wrapper" key="selected" ref="cardWrapper">
                            <div v-for="(option, i) in southAmerica" class="question-card" @click="selectOption(option, i)" ref="questionCard">
                                <div :class="{'active': selectedOptions.indexOf(option) > -1}" >
                                    <img class="question-card-img" :src="require('coffee-preferences/' + option.image_name)" alt="Question Image">
                                    <p class="option-name">{{ option.name }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="region == 'Africa'">
                    <div class="countRow">
                        <div class="cotryhead outerwrap">
                            <div class="topbx">
                                <label class="form-check-label" for="africa"> Africa
                                    <input type="checkbox" id="africa" v-bind:value='region' v-model='regions' @change='updateCheckall()' ref="allAfrica">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="btmbx descpbx">
                                <h5>In terms of the taste profile, African coffees are known to be more fruity, floral, and aromatic. They are vibrant with notes of berries, peaches, and tropical fruit. This is often due to how prolific Natural process coffees are in this region. The fruity flavors can be accompanied by floral notes of  jasmine, bergamot, as well as a bright profile. They are not bitter, but vibrant and lively, with a wine-like acidity that can be compared to green apple or sparkling wine.</h5>
                            </div>
                        </div>
                        <div class="question-cards-wrapper" key="selected" ref="cardWrapper">
                            <div v-for="(option, i) in africa" class="question-card" @click="selectOption(option, i)" ref="questionCard">
                                <div :class="{'active': selectedOptions.indexOf(option) > -1}" >
                                    <img class="question-card-img" :src="require('coffee-preferences/' + option.image_name)" alt="Question Image">
                                    <p class="option-name">{{ option.name }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="countRow">
                        <div class="cotryhead outerwrap">
                            <div class="topbx">
                                <label class="form-check-label" for="asiaHawai"> Asia and Hawaii
                                    <input type="checkbox" id="asiaHawai" v-bind:value='region' v-model='regions' @change='updateCheckall()' ref="allAsiaHawaii">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="btmbx descpbx">
                                <h5>Silky, rich, earthy, spicy, savory, and wild are the words most commonly used to describe Southeast Asia’s extraordinary arabica coffees. Indonesian coffees are the wild children of coffee — untamed and earthy with rich syrup-like mouthfeels, these beans, grown in volcanic ash amongst chilis and spices are unique among coffees for their near-savory upper notes. Papua New Guinea coffees are savory and wonderfully rich with delicate earth and spice tones.</h5>
                            </div>
                        </div>
                        <div class="question-cards-wrapper" key="selected" ref="cardWrapper">
                            <div v-for="(option, i) in  asiaHawaii" class="question-card" @click="selectOption(option, i)" ref="questionCard">
                                <div :class="{'active': selectedOptions.indexOf(option) > -1}" >
                                    <img class="question-card-img" :src="require('coffee-preferences/' + option.image_name)" alt="Question Image">
                                    <p class="option-name">{{ option.name }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="pageNumber  == 8">
            <p class="aplyLabel">Please rate the importance of buying only fully transparent, equitable trade (aka Direct trade) and fair trade coffees to you</p>
            <div class="progress-bar-wrapper" v-show="isVisible">
                <div class="progress"><span :style="{left: percent}" class="progress-no">{{percent}}</span>
                    <div class="progress-bar" role="progressbar" :style="{width: percent}" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
            </div>
            <div class="question-cards-wrapper rating-wrpper" key="selected" ref="cardWrapper">
                <div class="steps-wrapper">
                    <ul>
                        <li v-for="(option, i) in options" @click="selectTradeOption(option, i)"  ref="questionCard">
                        <div :class="{'active-new': selectedOptions.indexOf(option) > -1}">
                            <div v-if="option.name == 'Anything is fine'">
                                <div class="top-circle-outer">
                                    <div class="top-circle-inner">
                                        <span>01</span>
                                        <svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.8216 27.9984C14.7269 27.9984 14.6333 27.9788 14.5466 27.9409C14.4599 27.9029 14.382 27.8475 14.3177 27.778L0.733073 13.0833C0.642514 12.9853 0.582479 12.8631 0.560316 12.7315C0.538153 12.6 0.554823 12.4648 0.608285 12.3426C0.661748 12.2203 0.749684 12.1163 0.861332 12.0433C0.972979 11.9703 1.10349 11.9314 1.2369 11.9314H7.77581C7.87398 11.9314 7.97101 11.9525 8.06036 11.9932C8.1497 12.0339 8.22927 12.0933 8.2937 12.1673L12.8337 17.3905C13.3244 16.3417 14.2742 14.5953 15.941 12.4673C18.4051 9.32138 22.9883 4.69468 30.8298 0.518018C30.9814 0.437309 31.1577 0.416362 31.3239 0.459313C31.4902 0.502264 31.6343 0.605991 31.7278 0.750012C31.8213 0.894033 31.8574 1.06788 31.829 1.23722C31.8005 1.40656 31.7097 1.55909 31.5743 1.66469C31.5443 1.68809 28.5209 4.06899 25.0414 8.43002C21.839 12.4432 17.5821 19.0055 15.4874 27.4772C15.4506 27.6261 15.365 27.7583 15.2443 27.8528C15.1236 27.9473 14.9747 27.9987 14.8214 27.9987L14.8216 27.9984Z" fill="#A994B7"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="step-text"><p>{{option.name}}</p></div>
                            </div>
                            <div v-if="option.name == 'Sometimes'">
                                <div class="top-circle-outer">
                                    <div class="top-circle-inner">
                                        <span>02</span>
                                        <svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.8216 27.9984C14.7269 27.9984 14.6333 27.9788 14.5466 27.9409C14.4599 27.9029 14.382 27.8475 14.3177 27.778L0.733073 13.0833C0.642514 12.9853 0.582479 12.8631 0.560316 12.7315C0.538153 12.6 0.554823 12.4648 0.608285 12.3426C0.661748 12.2203 0.749684 12.1163 0.861332 12.0433C0.972979 11.9703 1.10349 11.9314 1.2369 11.9314H7.77581C7.87398 11.9314 7.97101 11.9525 8.06036 11.9932C8.1497 12.0339 8.22927 12.0933 8.2937 12.1673L12.8337 17.3905C13.3244 16.3417 14.2742 14.5953 15.941 12.4673C18.4051 9.32138 22.9883 4.69468 30.8298 0.518018C30.9814 0.437309 31.1577 0.416362 31.3239 0.459313C31.4902 0.502264 31.6343 0.605991 31.7278 0.750012C31.8213 0.894033 31.8574 1.06788 31.829 1.23722C31.8005 1.40656 31.7097 1.55909 31.5743 1.66469C31.5443 1.68809 28.5209 4.06899 25.0414 8.43002C21.839 12.4432 17.5821 19.0055 15.4874 27.4772C15.4506 27.6261 15.365 27.7583 15.2443 27.8528C15.1236 27.9473 14.9747 27.9987 14.8214 27.9987L14.8216 27.9984Z" fill="#A994B7"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="step-text"><p>{{option.name}}</p></div>
                            </div>
                            <div v-if="option.name == '50% of my selection'">
                                <div class="top-circle-outer">
                                    <div class="top-circle-inner">
                                        <span>03</span>
                                        <svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.8216 27.9984C14.7269 27.9984 14.6333 27.9788 14.5466 27.9409C14.4599 27.9029 14.382 27.8475 14.3177 27.778L0.733073 13.0833C0.642514 12.9853 0.582479 12.8631 0.560316 12.7315C0.538153 12.6 0.554823 12.4648 0.608285 12.3426C0.661748 12.2203 0.749684 12.1163 0.861332 12.0433C0.972979 11.9703 1.10349 11.9314 1.2369 11.9314H7.77581C7.87398 11.9314 7.97101 11.9525 8.06036 11.9932C8.1497 12.0339 8.22927 12.0933 8.2937 12.1673L12.8337 17.3905C13.3244 16.3417 14.2742 14.5953 15.941 12.4673C18.4051 9.32138 22.9883 4.69468 30.8298 0.518018C30.9814 0.437309 31.1577 0.416362 31.3239 0.459313C31.4902 0.502264 31.6343 0.605991 31.7278 0.750012C31.8213 0.894033 31.8574 1.06788 31.829 1.23722C31.8005 1.40656 31.7097 1.55909 31.5743 1.66469C31.5443 1.68809 28.5209 4.06899 25.0414 8.43002C21.839 12.4432 17.5821 19.0055 15.4874 27.4772C15.4506 27.6261 15.365 27.7583 15.2443 27.8528C15.1236 27.9473 14.9747 27.9987 14.8214 27.9987L14.8216 27.9984Z" fill="#A994B7"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="step-text"><p>{{option.name}}</p></div>
                            </div>
                            <div v-if="option.name == 'I mostly want these'">
                                <div class="top-circle-outer">
                                    <div class="top-circle-inner">
                                        <span>04</span>
                                        <svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.8216 27.9984C14.7269 27.9984 14.6333 27.9788 14.5466 27.9409C14.4599 27.9029 14.382 27.8475 14.3177 27.778L0.733073 13.0833C0.642514 12.9853 0.582479 12.8631 0.560316 12.7315C0.538153 12.6 0.554823 12.4648 0.608285 12.3426C0.661748 12.2203 0.749684 12.1163 0.861332 12.0433C0.972979 11.9703 1.10349 11.9314 1.2369 11.9314H7.77581C7.87398 11.9314 7.97101 11.9525 8.06036 11.9932C8.1497 12.0339 8.22927 12.0933 8.2937 12.1673L12.8337 17.3905C13.3244 16.3417 14.2742 14.5953 15.941 12.4673C18.4051 9.32138 22.9883 4.69468 30.8298 0.518018C30.9814 0.437309 31.1577 0.416362 31.3239 0.459313C31.4902 0.502264 31.6343 0.605991 31.7278 0.750012C31.8213 0.894033 31.8574 1.06788 31.829 1.23722C31.8005 1.40656 31.7097 1.55909 31.5743 1.66469C31.5443 1.68809 28.5209 4.06899 25.0414 8.43002C21.839 12.4432 17.5821 19.0055 15.4874 27.4772C15.4506 27.6261 15.365 27.7583 15.2443 27.8528C15.1236 27.9473 14.9747 27.9987 14.8214 27.9987L14.8216 27.9984Z" fill="#A994B7"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="step-text"><p>{{option.name}}</p></div>
                            </div>
                            <div v-if="option.name == 'I only want these'">
                                <div class="top-circle-outer">
                                    <div class="top-circle-inner">
                                        <span>05</span>
                                        <svg width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14.8216 27.9984C14.7269 27.9984 14.6333 27.9788 14.5466 27.9409C14.4599 27.9029 14.382 27.8475 14.3177 27.778L0.733073 13.0833C0.642514 12.9853 0.582479 12.8631 0.560316 12.7315C0.538153 12.6 0.554823 12.4648 0.608285 12.3426C0.661748 12.2203 0.749684 12.1163 0.861332 12.0433C0.972979 11.9703 1.10349 11.9314 1.2369 11.9314H7.77581C7.87398 11.9314 7.97101 11.9525 8.06036 11.9932C8.1497 12.0339 8.22927 12.0933 8.2937 12.1673L12.8337 17.3905C13.3244 16.3417 14.2742 14.5953 15.941 12.4673C18.4051 9.32138 22.9883 4.69468 30.8298 0.518018C30.9814 0.437309 31.1577 0.416362 31.3239 0.459313C31.4902 0.502264 31.6343 0.605991 31.7278 0.750012C31.8213 0.894033 31.8574 1.06788 31.829 1.23722C31.8005 1.40656 31.7097 1.55909 31.5743 1.66469C31.5443 1.68809 28.5209 4.06899 25.0414 8.43002C21.839 12.4432 17.5821 19.0055 15.4874 27.4772C15.4506 27.6261 15.365 27.7583 15.2443 27.8528C15.1236 27.9473 14.9747 27.9987 14.8214 27.9987L14.8216 27.9984Z" fill="#A994B7"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="step-text"><p>{{option.name}}</p></div>
                            </div>
                        </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>        
        <div v-else>
            <p class="aplyLabel">Select all that apply</p>
            <div class="progress-bar-wrapper" v-show="isVisible">
                <div class="progress"><span :style="{left: percent}" class="progress-no">{{percent}}</span>
                    <div class="progress-bar" role="progressbar" :style="{width: percent}" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
            </div>
            <div class="question-cards-wrapper" key="selected" ref="cardWrapper">
                <div v-for="(option, i) in options" class="question-card" @click="selectOption(option, i)" ref="questionCard">
                    <div :class="{'active': selectedOptions.indexOf(option) > -1}" >
                        <img class="question-card-img" :src="require('coffee-preferences/' + option.image_name)" alt="Question Image">
                        <p class="option-name">{{ option.name }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="(optionSelected) && (count > 0) && (preAnswer == undefined)" class="confrmbtn-holder">
            <button @click="onAnswered(selectedOptions, indexes),  preAnswer = selectedOptions" class="button purple-btn confirm-btn-lg btn-fat margin-top-sm">Next</button>
        </div>
        <div v-if="(optionSelected) && (count > 0) && (preAnswer != undefined) && (preAnswer != selectedOptions)" class="confrmbtn-holder">
            <button @click="onAnswered(selectedOptions, indexes),  preAnswer = selectedOptions" class="button purple-btn confirm-btn-lg btn-fat margin-top-sm">Save</button>
        </div>
        <div v-if="!optionSelected">
            <button @click="check_data(selectedOptions, indexes)" class="button light-purple-btn confirm-btn-lg btn-fat margin-top-sm">Next</button>
        </div>
        <div v-if="!optionSelected " class="question-tip">
            <img class="question-tip-icon" :src="require('home/onboarding/light-bulb-icon')" alt="Onboarding Question">
            {{ tip }}
        </div>
    </div>
</template>

<script>
    import AnimationMixin from '../../../mixins/animation';

    export default {
        props: {
            pageNumber: Number,
            numQuestions: Number,
            heading: String,
            options: Array,
            tip: String
        },
        mixins: [
            AnimationMixin
        ],
        data: function() {
            return  {
                optionSelected: undefined,
                animationTimeLine: undefined,
                selectedOptions: [],
                selectall : false,
                indexes: [],
                regionOptions: ["Central America", "South America", "Africa", "Asia & Hawaii"],
                regions: [],
                isCheckAll: false,
                count: 0,
                matchingValue: 0,
                unMatchingValue: 0,
                selectedOptionsCentral: [],
                centralcheckbox: undefined,
                southcheckbox:undefined,
                africacheckbox: undefined,
                asiacheckbox: undefined,
                centralVal: [],
                southVal: [],
                afircaVal: [],
                asiaVal: [],
                percent: "0%",
                countryArray: [],
                isVisible: true, 
                preAnswer: undefined
            }
        },
        methods: {
            checkAll: function(){
                this.isCheckAll = !this.isCheckAll;
                this.regions = [];
                this.count = 0;
                this.selectedOptions = [];
                if(this.isCheckAll){
                    for (var key in this.regionOptions) {
                        this.regions.push(this.regionOptions[key]);
                    }
                this.selectedOptions.push(this.selectAllCountry());
                this.selectedOptions = this.selectedOptions.flat();
                this.optionSelected = this.selectedOptions[0];
                this.count++;
                this.percent = "87.5%";
                }
                if (!this.isCheckAll){
                    this.centralcheckbox = document.getElementById('cntralAmerica');
                    this.centralcheckbox.checked = false;
                    this.southcheckbox = document.getElementById('southAmrica');
                    this.southcheckbox.checked = false;
                    this.africacheckbox = document.getElementById('africa');
                    this.africacheckbox.checked = false;
                    this.asiacheckbox = document.getElementById('asiaHawai');
                    this.asiacheckbox.checked = false ;
                }
                this.progressBarPercent();
            },
             updateCheckall: function(){
                if(this.regions.length == this.regionOptions.length){
                    this.isCheckAll = true;
                    this.selectedOptions.push(this.options.filter(r => r.category ==  "country_of_origin"));
                    this.centralVal = [];
                    this.southVal = [];
                    this.afircaVal = [];
                    this.asiaVal = [];
                }else{
                    this.isCheckAll = false;
                    this.regions = this.regions.filter((value, index, self) => {return self.indexOf(value) === index; });
                    if (this.regions.length > 0) {
                        for (var key in this.regions){  
                            if(this.regions[key] == "Central America"){
                                this.count = 0;
                                this.selectedOptions.push(this.centralAmerica);
                                this.count++;
                                this.centralVal = [];
                            }else if (!this.regions.includes("Central America")) {
                                this.selectedOptions = this.selectedOptions.filter((value) => !this.centralAmerica.includes(value));
                                this.selectedOptions.push(this.centralVal);
                            }
                            
                            if(this.regions[key] == "South America"){
                                this.count = 0;
                                this.selectedOptions.push(this.southAmerica);
                                this.count++;
                                this.southVal = [];
                            }else if (!this.regions.includes("South America")) {
                                this.selectedOptions = this.selectedOptions.filter((value) => !this.southAmerica.includes(value));
                                this.selectedOptions.push(this.southVal);
                            }

                            if(this.regions[key] == "Africa"){
                                this.count = 0;
                                this.selectedOptions.push(this.africa);
                                this.count++;
                                this.afircaVal = [];
                            }else if (!this.regions.includes("Africa")) {
                                this.selectedOptions = this.selectedOptions.filter((value) => !this.africa.includes(value));
                                this.selectedOptions.push(this.afircaVal);
                            }

                            if (this.regions[key] == "Asia & Hawaii"){
                                this.count = 0;
                                this.selectedOptions.push(this.asiaHawaii);
                                this.count++;
                                this.asiaVal = [];
                            }else if (!this.regions.includes("Asia & Hawaii")) {
                                this.selectedOptions = this.selectedOptions.filter((value) => !this.asiaHawaii.includes(value));
                                this.selectedOptions.push(this.asiaVal);
                            }
                        }
                        this.percent = "87.5%";
                        this.optionSelected = this.selectedOptions[0];
                    }else{
                        this.selectedOptions = [];
                        this.percent = "75%";
                        this.count = 0;
                        this.optionSelected = undefined;
                    }

                    if (this.regions.includes(this.regionOptions)){
                        this.isCheckAll = true;
                    }
                }             
                this.selectedOptions = this.selectedOptions.flat(); 
                this.selectedOptions = this.selectedOptions.filter((value, index, self) => {return self.indexOf(value) === index; });
             },

            onAnswered(options, indexes) {
                this.$emit('answered', options.filter((r) => r !== undefined));
                if (this.count >= 0){
                    this.count--;
                }
                this.isVisible = false
            },
            check_data(options, indexes) {
                alert("Please select any answer for this question.");
            },
            onOptionDeselected() {
                if (!this.optionSelected) {
                    return;
                }
                this.$emit('deselected', this.optionSelected);
                this.optionSelected = undefined;
            },
            selectOption(option, index) {
                this.selectedOptions.push(option);
                this.indexes.push(index);
                this.centralcheckbox = document.getElementById('cntralAmerica');
                this.southcheckbox = document.getElementById('southAmrica');
                this.africacheckbox = document.getElementById('africa');
                this.asiacheckbox = document.getElementById('asiaHawai');
                if (this.selectedOptions.filter((item, index) => this.selectedOptions.indexOf(item) !== index).length > 0){
                    for(let i=0; i<this.selectedOptions.length; i++){
                        if(this.selectedOptions[i] == option){
                            delete this.selectedOptions[i];
                            this.optionSelected = undefined;
                            this.progressBarPercent();
                        }
                    }
                }
                name = this.selectedOptions.filter((r) => r !== undefined)[0].key;
                if (option.key == 'unsure'){
                    for(let i=0; i<this.selectedOptions.length; i++){
                        if(this.selectedOptions[i] !== option){
                            delete this.selectedOptions[i];
                        }
                    }
                }
                if ((name == 'unsure') && (option.key !== 'unsure')){
                    delete this.selectedOptions[0];
                }
                this.selectedOptions = this.selectedOptions.filter((r) => r !== undefined); 
                this.optionSelected = this.selectedOptions

                if (this.optionSelected && this.pageNumber == 1){                
                    this.percent = "12.5%";
                }else if (this.optionSelected && this.pageNumber == 2){
                     this.percent = "25%";
                }else if (this.optionSelected && this.pageNumber == 3){                
                    this.percent = "37.5%";
                }else if (this.optionSelected && this.pageNumber == 4){
                     this.percent = "50%";
                }else if (this.optionSelected && this.pageNumber == 5){                
                    this.percent = "62.5%";
                }else if (this.optionSelected && this.pageNumber == 6){
                     this.percent = "75%";
                }else if (this.optionSelected && this.pageNumber == 7){                
                    this.percent = "87.5%";
                }


                this.unMatchingValue = 0;
                var southAmericaValue = 0;
                var africaValue = 0;
                var asiaHawaiValue = 0;
                this.regions = [];
                if (option.category == "country_of_origin"){
                    this.centralVal = [];
                    for(var i=0; i<this.centralAmerica.length; i++){
                        if(this.selectedOptions.includes(this.centralAmerica[i])){
                            this.matchingValue = 0;
                            this.centralVal.push(this.centralAmerica[i]);
                        }else{
                            this.unMatchingValue++;
                        }
                    }
                    if (this.unMatchingValue != 0){
                        this.centralcheckbox.checked = false;
                        for(var key in this.regions){
                            if(this.regions[key] == "Central America"){
                                delete this.regions[key];
                            }
                        }
                        this.centralVal = this.centralVal.filter((value, index, self) => {return self.indexOf(value) === index; });
                        this.regions = this.regions.filter(r => r != '');    
                    }else{
                       this.centralcheckbox.checked = true;
                       this.regions.push("Central America");
                       this.centralVal = [];
                    }
                    
                    this.southVal = [];
                    for(let i=0; i<this.southAmerica.length; i++){
                        if(this.selectedOptions.includes(this.southAmerica[i])){
                            this.matchingValue = 0;
                            this.southVal.push(this.southAmerica[i]);
                        }else{
                            southAmericaValue++;
                        }
                    }
                    if (southAmericaValue != 0){
                        this.southcheckbox.checked = false;
                        for(var key in this.regions){
                            if(this.regions[key] == "South America"){
                                delete this.regions[key];
                            }
                        }
                        this.southVal = this.southVal.filter((value, index, self) => {return self.indexOf(value) === index; });
                        this.regions = this.regions.filter(r => r != '');
                    }else{
                        this.southcheckbox.checked = true;
                        this.regions.push("South America");
                        this.southVal = [];
                    }
                    
                    this.afircaVal = [];
                    for(let i=0; i<this.africa.length; i++){
                        if(this.selectedOptions.includes(this.africa[i])){
                            this.matchingValue = 0;
                            this.afircaVal.push(this.africa[i]);
                        }else{
                            africaValue++;
                        }
                    }
                    if (africaValue != 0){
                        this.africacheckbox.checked = false;
                        for(var key in this.regions){
                            if(this.regions[key] == "Africa"){
                                delete this.regions[key];
                            }
                        }
                        this.afircaVal = this.afircaVal.filter((value, index, self) => {return self.indexOf(value) === index; });
                        this.regions = this.regions.filter(r => r != '');
                    }else{
                        this.africacheckbox.checked = true;
                        this.regions.push("Africa");
                        this.afircaVal = [];
                    }

                    this.asiaVal = [];
                    for(let i=0; i<this.asiaHawaii.length; i++){
                        if(this.selectedOptions.includes(this.asiaHawaii[i])){
                            this.matchingValue = 0;
                            this.asiaVal.push(this.asiaHawaii[i]);    
                        }else{
                            asiaHawaiValue++;
                        }
                    }                
                    if (asiaHawaiValue != 0){
                        this.asiacheckbox.checked = false;
                        for(var key in this.regions){
                            if(this.regions[key] == "Asia & Hawaii"){
                                delete this.regions[key];
                            }
                        }
                        this.asiaVal = this.asiaVal.filter((value, index, self) => {return self.indexOf(value) === index; });
                        this.regions = this.regions.filter(r => r != '');
                    }else{
                        this.asiacheckbox.checked = true;
                        this.regions.push("Asia & Hawaii");
                        this.asiaVal = []; 
                    }
                    
                    if ( (this.asiacheckbox.checked == true) && (this.africacheckbox.checked == true) && (this.southcheckbox.checked == true) && (this.centralcheckbox.checked == true)){
                        this.isCheckAll = true;
                        this.asiaVal = [];
                        this.afircaVal = [];
                        this.southVal = [];
                        this.centralVal = [];
                    }else{
                        this.isCheckAll = false;
                    }
                }

                this.count=0;
                this.count++;

                return this.selectedOptions.filter((r) => r !== undefined);
            },
            selectTradeOption(option, index){
                this.count = 0;
                this.selectedOptions.push(option);
                if (this.selectedOptions.filter((item, index) => this.selectedOptions.indexOf(item) !== index).length > 0){
                    for(let i=0; i<this.selectedOptions.length; i++){
                        if(this.selectedOptions[i] == option){
                            delete this.selectedOptions[i];
                            this.optionSelected = undefined;
                        }
                    }
                }
                if(this.optionSelected != undefined && this.optionSelected != option ){
                    this.selectedOptions = [];
                    this.selectedOptions.push(option);
                }
                this.count++;
                this.selectedOptions = this.selectedOptions.filter((r) => r !== undefined);
                if (this.selectedOptions != '' ){
                        this.percent = "100%";
                        this.optionSelected = this.selectedOptions;
                    }
                else{
                    this.optionSelected = undefined;
                    this.progressBarPercent();
                }
                
                return this.selectedOptions;
            },
            selectAllCountry(){
                this.selectedOptions = []
                if (this.$refs.selectAllCheckbox.checked) {
                    this.selectedOptions.push(this.options.filter(r => r.category ==  "country_of_origin"));
                }

                return this.selectedOptions.flat();
            },
            progressBarPercent(){
                if((!this.optionSelected) && (this.pageNumber == 1)){
                    this.percent = "0%";
                }else if((!this.optionSelected) && (this.pageNumber == 2)){
                    this.percent = "12.5%";
                }else if((!this.optionSelected) && (this.pageNumber == 3)){
                    this.percent = "25%";
                }else if((!this.optionSelected) && (this.pageNumber == 4)){
                    this.percent = "37.5%";
                }else if((!this.optionSelected) && (this.pageNumber == 5)){
                    this.percent = "50%";
                }else if((!this.optionSelected) && (this.pageNumber == 6)){
                    this.percent = "62.5%";
                }else if(((!this.optionSelected) || (this.isCheckAll == false)) && (this.pageNumber == 7)){
                    this.percent = "75%";
                }else if((!this.optionSelected) && (this.pageNumber == 8)){
                    this.percent = "87.5%";
                }
            }
        },
        computed: {
            centralAmerica() {
                const countries = this.options.filter(r => r.category ==  "country_of_origin");
                var countryOfCentral = [];
                for(let i=0; i<=7; i++){
                    countryOfCentral.push(countries[i]);
                }
                return countryOfCentral;
            },
             southAmerica() {
                const countries = this.options.filter(r => r.category ==  "country_of_origin");
                let countryOfSouth = [];
                for(let i=8; i<=12; i++){
                   countryOfSouth.push(countries[i]);
                }
                return countryOfSouth;
            },
            africa(){
                const countries = this.options.filter(r => r.category ==  "country_of_origin");
                let africa = [];
                for(let i=13; i<=21; i++){
                   africa.push(countries[i]);
                }
                return africa;
            },
            asiaHawaii(){
                const countries = this.options.filter(r => r.category ==  "country_of_origin");
                let asiaHawaii = [];
                for(let i=22; i<=26; i++){
                   asiaHawaii.push(countries[i]);
                }
                return asiaHawaii;
            }
        },
        mounted() {
                if(this.pageNumber == 1){
                    this.percent = "0%";
                } else if(this.pageNumber == 2){
                    this.percent = "12.5%";
                } else if(this.pageNumber == 3){
                    this.percent = "25%";
                }else if(this.pageNumber == 4){
                    this.percent = "37.5%";
                }else if(this.pageNumber == 5){
                    this.percent = "50%";
                }else if(this.pageNumber == 6){
                    this.percent = "62.5%";
                }else if(this.pageNumber == 7){
                    this.percent = "75%";
                }else if(this.pageNumber == 8){
                    this.percent = "87.5%";
                }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/variables_home";
    @import "../../../styles/common_home";

    .question {
        max-width: 1000px;
        margin: auto;
        padding-top: 3rem;
        text-align: center;
        position: relative;
    }
    .scroll-point {
        position: absolute;
        top: -80px;
    }
    .page-number {
        margin-bottom: 0;
    }
    .question-heading {
        margin: 0 .5rem 0.2rem;
        letter-spacing: -1px;
    }

    .active {
        position: absolute;
        width: 213px;
        height: 275px;
        left: 291px;
        top: 392px;
        background: #F7F1FB;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
    }
    .question-cards-wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }
    .question-card {
        box-sizing: border-box;
        width: 20vw;
        height: 20vw;
        max-width: 220px;
        max-height: 220px;
        min-width: 160px;
        min-height: 160px;
        margin-top: 2rem;
        margin-bottom: 1rem;
        cursor: pointer;
        transition: 1s;
        //overflow: hidden;

        img{
             transition: 0.2s all linear;
        }
       
       .option-name{
         transition: 0.2s all linear;
       }
        /*  &:hover {
            font-weight: bold;
        } */
        div{
        position: relative;
        padding: 20px;
        &:before{
        content: "";
        position: absolute;
        height: calc(100%);
        width: calc(100%);
        top: 0;
        background: #f2dfff;
        left: 0;
        transform: scale(0);
        transition: 0.2s all linear;
        z-index: -1;
        box-shadow: 2px 4px 8px -2px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        }
        &.active{
            position: relative;
            width: unset;
            background: transparent;
            box-shadow: none;
            height: unset;
            top: unset;
            left: unset;
            z-index: 9;
            /* animation: abc 0.5s linear; */
           transition:0.2s all linear;

            .option-name{
                font-weight:700;
                padding-top: 15px;
                transition: 0.2s all linear;
            }

        &:before{
            transform:scale(1);
            transition:0.2s all linear
            }  
             img{
                 transform: scale(1.1);
                transition: 0.2s all linear;
            }       
        }

        /*&:hover{
             animation: abc 0.5s linear;
             z-index: 9;
           &:before{
            transform:scale(1);
            transition:0.2s all linear
            }    
        }*/
    }
    }
    .question-card-img {
        width: 80%;
        height: 80%;
        margin-bottom: .5rem;
    }
    .option-name {
        margin: 0;
    }
    .question-tip {
        width: 400px;
        margin: 3rem auto;
        padding: 2rem;
        border: 1px solid $color-primary;
        border-radius: 11px;
        position: relative;
        margin-bottom: 16px;

    }
    .question-tip-icon {
        width: 30px;
        height: 30px;
        position: absolute;
        top: -15px;
        left: 211px;
    }

    .worldMap-holder .image-container {
        max-width: 380px;
        &.active{
            position: relative;
            width: unset;
            background: transparent;
            box-shadow: none;
            height: unset;
            top: unset;
            left: unset;
            z-index: 9;
            animation: abc 0.5s linear;

            &:before{
                transform:scale(1);
                transition:0.2s all linear
            }
        }
        /*&:hover{
            animation: abc 0.5s linear;
            z-index: 9;
            &:before{
                transform:scale(1);
                transition:0.2s all linear
            }    
        }*/
    }
    .worldMap-holder .image-container.active {
        position: relative;
        width: 380px;
        height: 244px;
        left: 40px;
        top: 0px;
        background: #F7F1FB;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        max-width: 380px;
    }
    .cotryhead {
        text-align: left;
        position: relative;
        padding-left: 35px;
        border-top: 1px solid #E9E9E9;
        padding-top: 25px;
        padding-bottom: 20px;
    }
    .cotryhead .descpbx h5 {
        font-weight: 400;
        font-size: 14px;
        color: #3D547C;
        line-height: 120%;
        margin: 10px 0 20px;
    }
    .cotryhead .topbx .form-check-label {
        font-size: 24px;
        color: #3D547C;
        font-weight: 500;
    }

    .form-check-label {
        display: block;
        position: relative;
        padding-left: 0;
        margin-bottom: 0;
        cursor: pointer;
        font-size: 24px;
        line-height: 1.2;
        color: #3D547C;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .form-check-label input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    .form-check-label .checkmark {
        position: absolute;
        top: 1px;
        left: -35px;
        height: 25px;
        width: 25px;
        border-radius: 50%;
        background-color: #fff;
        border: 1px solid #E6E6E6;
    }

    .form-check-label:hover input ~ .checkmark {
        border-color: #A994B7;
    }

    .form-check-label input:checked ~ .checkmark {
        background-color: #A994B7;
        border-color: #A994B7;
    }

    .form-check-label .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    .form-check-label input:checked ~ .checkmark:after {
        display: block;
    }
    .form-check-label .checkmark:after {
        left: 9px;
        top: 4px;
        width: 6px;
        height: 12px;
        border: solid white;
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
    .selectAll-container {
        padding-bottom: 36px;
    }
    .purple-btn {
        background: #c1a6d3;
    }
    .light-purple-btn{
        background: #dccee5;
    }

    .light-purple-btn.confirm-btn-lg {
        border-radius: 80px;
    }
    .btn-fat {
        min-width: 180px;
        padding: 0.5rem 3rem;
        height: 4rem;
    }
    .purple-btn.confirm-btn-lg {
        border-radius: 80px;
    }
    .steps-wrapper {
        width:100%;
    }
    .steps-wrapper ul {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    list-style: none;
    padding: 0;
    margin: 20px 0;
    padding: 0 12px;
    width:100%;
    }

    .steps-wrapper ul li {
    width: 20%;
    max-width: 172px;
    
    }
    .steps-wrapper ul li > div{
        padding: 30px 14px;
    }

    .progress {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 10px;
    background: #f3f6fb;
    border-radius: 10px;
    position: relative;
    }

    .progress-bar {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    transition: width 0.6s ease;
    background: linear-gradient(to right, #d6b7eb, #d0f4ff);
    border-radius: 10px;
    }

    li .active-new {
    background: #f2dfff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    }

    .top-circle-outer {
    border-radius: 50%;
    background: #ffffff;
    border: 1px dashed rgba(61, 84, 124, 0.2);
    width: 66px;
    height: 66px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    margin-bottom: 12px;
    }

    .steps-wrapper ul li {
    position: relative;
    }

    .steps-wrapper ul li .top-circle-inner svg,
    .steps-wrapper ul li .top-circle-inner img {
    display: none;
    }

    .steps-wrapper ul li .active-new .top-circle-inner svg,
    .steps-wrapper ul li .active-new .top-circle-inner img {
    display: block;
    }

    .steps-wrapper ul li .active-new .top-circle-inner span {
    display: none;
    }

    .top-circle-inner {
    border-radius: 50%;
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    background: #f2f7ff;
    font-weight: 500;
    font-size: 24px;
    line-height: 118%;
    text-align: center;
    letter-spacing: -0.04em;
    color: #6f7e97;
    }

    li .active-new.top-circle-inner {
    background: #ffffff;
    box-shadow: 0px 14px 14px rgba(61, 84, 124, 0.06);
    }

    li .active-new .top-circle-inner {
    background: #fff;
    }

    li .active-new .top-circle-outer {
    border: 1px dashed #3d547c;
    margin-bottom: 40px;
    }

    .step-text p {
    font-weight: 500;
    font-size: 16px;
    line-height: 118%;
    text-align: center;
    letter-spacing: -0.04em;
    color: #3d547c;
    margin-bottom: 0;
    padding: 0;
    }

    li .active-new .step-text p {
    font-weight: 700;
    }

    span.progress-no {
    background: #a994b7;
    border-radius: 6px;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 37px;
    font-weight: 700;
    font-size: 16px;
    line-height: 118%;
    text-align: center;
    color: #ffffff;
    bottom: -53px;
    overflow: visible;
    margin-left: -30px;
    }

    .progress-bar-wrapper {
    position: relative;
    width: 100%;
    padding: 30px 30px 53px 30px;
    }

    span.progress-no:after {
    content: "";
    position: absolute;
    width: 7px;
    height: 7px;
    border-radius: 2px;
    top: -3px;
    left: 0;
    right: 0;
    margin: auto;
    background: #a994b7;
    transform: rotate(45deg);
    z-index: -1;
    }

    .steps-wrapper ul li:before {
    content: "";
    position: absolute;
    top: 70px;
    border-top: 1px dashed rgba(61, 84, 124, 0.2);
    height: 1px;
    left: 50%;
    width: 100%;
    z-index: -1;
    }

    li .active-new .top-circle-outer {
    background: transparent;
    }

    .steps-wrapper ul li:last-child:before {
    display: none;
    }


    @keyframes abc {
        0% {
        transform: scale(1.0);
        }
        50% {
        transform: scale(1.1);
        }
        100% {
        transform: scale(1);
        }

    }

    @media only screen and (max-width: $max-tablet-width) {
        .question {
            padding-top: 2rem;
        }
        .scroll-point {
            top: -150px;
        }
        .question-heading {
            margin-bottom: 1rem;
        }
        .question-tip {
            width: 240px;
            margin-top: 2rem;
            padding: 1.5rem;
        }
        .question-tip-icon {
            position: absolute;
            top: -15px;
            left: 125px;
        }

        .question-card {
       
        div{
            &:hover{
             animation: none;
            &:before{
                transform:scale(0);
                transition:0.2s all linear
            }    
        }
        &.active{
            animation: abc 0.5s linear  !important;

        &:before{
            transform:scale(1) !important;
            transition:0.2s all linear
            }       
        }


    }
    }
    } 

    @media only screen and (max-width: 767px) {
        span.progress-no {
            width: 50px;
            height: 30px;
            font-size: 14px;
            bottom: -40px;
        }
        .question-cards-wrapper {
            margin: 0 -15px;
        }
        .steps-wrapper ul {
            margin: 0px 0 20px;
            padding: 0 0;
        }
        .steps-wrapper ul li:before {
            top: 54px;
        }
        .top-circle-outer {
            width: 36px;
            height: 36px;
            padding: 4px;
            margin-bottom: 12px;
        }
        .top-circle-inner {
            font-size: 14px;
        }
        .top-circle-inner svg {
            max-width: 20px;
        }
        .step-text p {
            font-size: 12px;
        }
        .steps-wrapper ul li > div {
            padding: 30px 6px;
        }
        .steps-wrapper ul li .active-new .top-circle-outer {
            margin-bottom: 20px;
        }

    }

    @media only screen and (max-width: 480px) {
        .step-text p {
            font-size: 11px;
        }
    }
</style>
